import React from 'react';
import Layout from '../../components/Layout/Layout';
import Fade from '@material-ui/core/Fade';
import { Button, makeStyles, Typography, Box, Container, TextField } from '@material-ui/core';
import { themeGreen } from '../../theme';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';


const useStyles = makeStyles(theme => ({
    MainWrapper: {
        height: 'calc(100vh - 66px)'
    },    
    Title: {
        width: '100%',         
        fontSize: '55px',
        fontWeight: 500,
        marginBottom: theme.spacing(5),
        [theme.breakpoints.down('sm')]: {
            fontSize: '45px',
            lineHeight: 1.2,
            marginBottom: theme.spacing(8),
        }
    },
    SubmitBtn: {
        marginTop: theme.spacing(8)
    },
    
    ActionsWrapper : {
        display: 'flex',
        justifyContent: 'flex-end'
    }
}));

function CategorySelector(props) {
    const [open, setOpen] = React.useState(false);
    const classes = useStyles(themeGreen);
    const [categories, setCategories] = React.useState([]);    
    const [value, setValue] = React.useState();
    const loading = open && categories.length === 0;


    React.useEffect(() => {
        console.log("querying rubros");
        let active = true;

        (async () => {
            const response = await fetch(`https://www.agroads.com.ar/reviews/api/es.asp?action=categories`);
            const categoriesAux = await response.json();
            if (active) {
                setCategories(categoriesAux.aggregations.rubro2.buckets.map(r => ({
                    id: r.rubro2_id.buckets[0].key,
                    title: r.key
                })))
            }
        })();

        return () => {
            active = false;
        };
    }, [])
    

    const handleNext = () => {
        if (value && value !== 0)
            props.history.push(`/r/${value}/modelo/`);
    }

    return (
        <Layout loading={loading}>
            {/* autocomplete de todos los rubros que tengan marca - modelo */}
            <Container maxWidth="lg">
                <Box display="flex" alignItems="center" className={classes.MainWrapper}>
                    <Fade in={true} timeout={1600}>
                        <div className={classes.FormWrapper}>
                            <Typography className={classes.Title}>Elegí una categoría.</Typography>                            
                            <Autocomplete
                                id="combo-box-demo"
                                open={open}
                                onOpen={() => {
                                    setOpen(true);
                                }}
                                onClose={() => {
                                    setOpen(false);
                                }}
                                getOptionSelected={(option, value) => option.title === value.title}
                                getOptionLabel={(option) => option.title}
                                options={categories}
                                loading={loading}                                
                                renderInput={(params) => 
                                    <TextField {...params} 
                                        placeholder="Ej. Tractores"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }} />
                                }
                                fullWidth
                                onChange={(event, newValue) => {
                                    setValue(newValue ? newValue.id : 0);
                                }}
                            />
                            <div className={classes.ActionsWrapper}>
                                <Button color="primary" variant="contained" className={classes.SubmitBtn} onClick={()=> handleNext()} disabled={value === 0 || !value}>Siguiente</Button>
                            </div>
                        </div>
                    </Fade>
                </Box>
            </Container>
        </Layout>
    )
}

export default CategorySelector;